import { makeStyles } from '@material-ui/core/styles'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import AllProducts from 'src/components/Individual/AllProducts'
import AllRenew from 'src/components/Individual/AllRenew'
import AllClaims from 'src/components/Individual/AllClaims'

const UpcomingFeatures = () => {
  const classes = useStyles()

  return (
    <Carousel
      infiniteLoop={true}
      showArrows={false}
      showStatus={false}
      showThumbs={false}
      showIndicators={true}
      autoPlay={true}
      stopOnHover={true}
      className={'w-100'}
    >
      <div className={classes.carouselItem}>
        <span className={classes.title}>Products</span>
        <AllProducts />
      </div>
      <div className={classes.carouselItem}>
        <span className={classes.title}>Renew</span>
        <AllRenew />
      </div>
      <div className={classes.carouselItem}>
        <span className={classes.title}>Claim</span>
        <AllClaims />
      </div>
    </Carousel>
  )
}

export default UpcomingFeatures

const useStyles = makeStyles({
  carouselItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '5px',
  },
  title: {
    fontWeight: 'bold',
    fontSize: '14px',
    marginBottom: '10px',
  },
})
